import React from 'react';
import styled from 'styled-components/macro';
import Colors from '../../Colors';
import GeneralDialog from '../../GeneralDialog';
import { MenuItem } from '@material-ui/core';
import { currencies } from '../../../components/form/Currency';
import { TextString } from '../../../components/Text';
import Select from '../../../components/engine/SelectEngine';

const CurrencySelectWrapper = styled.div``;

const H3 = styled.h3`
  margin: 0;
  font-size: 14px;
  color: #000;
`;

const InstructionContainer = styled.div`
  font-size: 14px;
  margin-bottom: 1rem;
`;

const SelectCurrencyTitle = styled.div`
  font-size: 12px;
`;

const NoteContainer = styled.div`
  font-style: italic;
  font-size: 12px;
`;

const CurrencyConversionSettingsPanelView = props => {
  return (
    <GeneralDialog
      titleBlockProps={{
        $customCSS: `background: ${Colors.PRIMARY}; h2 {color:#fff;}`
      }}
      customCSS={`svg[id='close-dialog'] {color: #fff;}`}
      buttons={[
        {
          text: 'forms.field_type.currency_conversion_save',
          onClick: props.clickedSave,
          disabled: props.saveDisabled
        }
      ]}
      disableBackdropClick
      handleClose={() => props.setShowCurrencyConversionDialog(false)}
      handleConfirm={props.clickedSave}
      maxWidth="sm"
      open={props.showCurrencyConversionDialog}
      title="forms.field_type.currency_conversion"
    >
      <CurrencySelectWrapper>
        <H3>
          <TextString content="forms.field.currency_conversion.question" />
        </H3>
        <InstructionContainer>
          <TextString content="forms.field.currency_conversion.answer" />
        </InstructionContainer>
        <SelectCurrencyTitle>
          <TextString content="forms.field.currency_conversion.select" />
        </SelectCurrencyTitle>
        <div>
          <Select
            searchable
            asyncOptions={props.asyncCurrencyOptions}
            openMenuOptionParser={props.openMenuOptionParser}
            variant="outlined"
            placeholder={props.placeholder}
            forceNonMobileVersion
            fullWidth
            data-testid={`select-currency`}
            value={props.currency}
            onChange={props.onCurrencyChanged}
          />
        </div>
        <NoteContainer>
          <TextString
            content="forms.field.currency_conversion.subtext"
            values={{ curr: props.currency }}
          />
        </NoteContainer>
      </CurrencySelectWrapper>
    </GeneralDialog>
  );
};

export default CurrencyConversionSettingsPanelView;
